export default {
    methods: {
        getLastSequenceNumber(items) {
            let sequence = 0;
            for (let item of items) {
                // if (item.active == true) {
                if (item.sequenceNumber > sequence) {
                    sequence = item.sequenceNumber;
                }
                // }
            }
            return sequence;
        },
        getNextSequenceNumber(items) {
            return this.getLastSequenceNumber(items) + 1;
        },
        getSortedList(arrayObject) {
            if (arrayObject) {
                if (arrayObject.length > 0) {
                    return arrayObject
                        // .filter((x) => x.active == true)
                        .sort((a1, a2) => a1.sequenceNumber - a2.sequenceNumber);
                }
            }
            return arrayObject;
        },
        setSequenceNumber(arrayObject, currentObject, newSequenceNumber) {
            newSequenceNumber = parseInt(newSequenceNumber);
            if (newSequenceNumber > currentObject.sequenceNumber) {
                this.setSequenceNumberUp(arrayObject, currentObject, newSequenceNumber);
            } else if (newSequenceNumber < currentObject.sequenceNumber) {
                this.setSequenceNumberDown(arrayObject, currentObject, newSequenceNumber);
            }
        },
        setSequenceNumberDown(arrayObject, currentObject, newSequenceNumber) {

            if (newSequenceNumber <= 0) {
                newSequenceNumber = 1;
            }

            let currentSequenceNumber = currentObject.sequenceNumber;

            let filteredObjects = arrayObject.filter(objectTemp =>
                objectTemp.sequenceNumber < currentSequenceNumber &&
                objectTemp.sequenceNumber >= newSequenceNumber
            );

            filteredObjects.forEach(objectTemp => {
                objectTemp.sequenceNumber++;
            });

            currentObject.sequenceNumber = newSequenceNumber;
        },
        setSequenceNumberUp(arrayObject, currentObject, newSequenceNumber) {

            let lastSequenceNumber = this.getLastSequenceNumber(arrayObject);
            if (newSequenceNumber > lastSequenceNumber) {
                newSequenceNumber = lastSequenceNumber;
            }

            let currentSequenceNumber = currentObject.sequenceNumber;

            let filteredObjects = arrayObject.filter(objectTemp =>
                objectTemp.sequenceNumber > currentSequenceNumber &&
                objectTemp.sequenceNumber <= newSequenceNumber
            );

            filteredObjects.forEach(objectTemp => {
                objectTemp.sequenceNumber--;
            });

            currentObject.sequenceNumber = newSequenceNumber;
        },
        updateIdWhenItGoesUp(arrayObject, currentObject) {
            this.setSequenceNumberDown(arrayObject, currentObject, currentObject.sequenceNumber - 1);
        },
        updateWhenGoDown(arrayObject, currentObject) {
            this.setSequenceNumberUp(arrayObject, currentObject, currentObject.sequenceNumber + 1);
        },
    }
}